import { Clock } from "lucide-react";
import React from "react";
import { Textarea, Stack } from "@mantine/core";
import { TimeInput } from "@mantine/dates";
import CapabilityProtectedComponent from "../../../common/uac/CapabilityProtectedComponent";
import { CAPABILITY_TA_OVERRIDE_CLOCK } from "../../../utils/UserAccessControlUtils";

interface OverrideFormProps {
  timestamp: Date | null;
  onTimestampChange: (value: Date) => void;
  reason: string;
  onReasonChange: (value: string) => void;
  errors?: {
    timestamp?: string;
    reason?: string;
  };
}

const OverrideForm: React.FC<OverrideFormProps> = ({
  timestamp,
  onTimestampChange,
  reason,
  onReasonChange,
  errors,
}) => (
  <CapabilityProtectedComponent
    requiredCapability={CAPABILITY_TA_OVERRIDE_CLOCK}
  >
    <Stack spacing="md">
      <TimeInput
        label="Time"
        icon={<Clock size={16} />}
        value={timestamp}
        onChange={onTimestampChange}
        error={errors?.timestamp}
        size="sm"
        format="24"
      />

      <Textarea
        label="Reason"
        placeholder="Explain why this override is necessary"
        minRows={3}
        value={reason}
        onChange={(e) => onReasonChange(e.currentTarget.value)}
        error={errors?.reason}
        size="sm"
      />
    </Stack>
  </CapabilityProtectedComponent>
);

export default OverrideForm;
